import axios from 'axios'
import BigNumber from 'bignumber.js'
import toast from 'react-hot-toast'
import { ChaingeChain, ChaingeToken, GasUsd } from 'types/baseType'
import request from 'utils/request'
import { setOrderStore } from 'utils/store'

// 获取资产列表
export interface ApiBalanceParams {
    chain: string
    address: string
    contractAddress: string
}
export const getEvmBalance = async (params: ApiBalanceParams) => {
    const {code = -1, data = {}}: any = await request.get('/getBalance', {
        params: params
    })
    if(code === 0) {
        return data.hrpBalance
    }
    return '0.0'
}

// 获取资产价格
export interface ApiPriceParams {
    chain: string
    symbol: string
    contractAddress: string
}
export const getEvmPrice = async (params: ApiPriceParams) => {
    const {code = -1, data = {}}: any = await request.get('/getPrice', {
        params: params
    })
    if(code === 0) {
        return data.price
    }
    return '0'
}


// 获取Aggregate交易询价列表
interface ApiCheckSupportParams {
    fromChain: ChaingeChain
    toChain: ChaingeChain
    fromToken: ChaingeToken
    toToken: ChaingeToken
}
export const checkAggregateSupportedToken = async (params: ApiCheckSupportParams) => {
   try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateSupportedToken')
        if(code === 0) {
            const { fromToken, toToken } = params
            const fromTokenSymbol = fromToken?.symbol
            const toTokenSymbol = toToken?.symbol

            const supportChainList = data.chains
            const keyChains: string[] = []
            supportChainList.forEach((item: any) => {
                keyChains.push(item.chainId)
            });
            const tokenObj: any = {}
            supportChainList.forEach((item: any) => {
                const tokens = item.tokens
                tokens.forEach((tokenItem: any) => {
                    tokenObj[tokenItem.symbol] = 1
                });
            });
            const tokenKeys = Object.keys(tokenObj)

            let isMainToken = false
            if(tokenKeys.includes(fromTokenSymbol) && tokenKeys.includes(toTokenSymbol)) {
                isMainToken = true
            }
            return {
                supportChains: keyChains,
                isMainToken
            }
        }
   } catch(error) {
        throw error
   }
}

interface ApiAggregateQuoteMainTokenParams {
    fromSymbol: string
    toSymbol: string
    fromAmount: string
}
export const getAggregateQuoteMainToken = async (params: ApiAggregateQuoteMainTokenParams, fromChainId: string, toChainId: string, gasUsdList: GasUsd[], isBaseCoin: boolean) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateQuoteMainToken', {params})
        if(code === 0) {
            const bestList = data?.best || []
            const otherList = data?.others || []

            let fromRouteList = []
            let toRouteList = []

            if(bestList.length) {
                fromRouteList = bestList.filter((item: any) => item?.chainId === fromChainId)
                toRouteList = bestList.filter((item : any) => item?.chainId === toChainId)
                // const fromRouterInfo = bestList.find((item : any) => item?.chainId === fromChainId)
                // if(fromRouterInfo) {
                //     return fromRouterInfo
                // }
                // const toRouterInfo = bestList.find((item : any) => item?.chainId === toChainId)
                // if(toRouterInfo) {
                //     return toRouterInfo
                // }
            }
            if(otherList.length) {
                const fromRouteListByOther = otherList.filter((item: any) => item?.chainId === fromChainId)
                const toRouteListByOther = otherList.filter((item : any) => item?.chainId === toChainId)

                fromRouteList = [...fromRouteList, ...fromRouteListByOther]
                toRouteList = [...toRouteList, ...toRouteListByOther]

                // const fromRouterInfo = otherList.find((item : any) => item?.chainId === fromChainId)
                // if(fromRouterInfo) {
                //     return fromRouterInfo
                // }
                // const toRouterInfo = otherList.find((item : any) => item?.chainId === toChainId)
                // if(toRouterInfo) {
                //     return toRouterInfo
                // }
            }
            if(fromRouteList.length) {
                fromRouteList = fromRouteList.map((item:any) => {
                    const amountOutUSDBN = new BigNumber(item.amountOutUSD || '0')
                    const gasUSDBN = new BigNumber('0')
                    const atLeastBN = amountOutUSDBN.minus(gasUSDBN)
                    item['atLeastBN'] = atLeastBN
                    item['amountOutUSDBN'] = amountOutUSDBN
                    return item
                })
                fromRouteList = bubbleSort(fromRouteList)
            }
            if(toRouteList.length) {
                toRouteList = toRouteList.map((item:any) => {
                    const amountOutUSDBN = new BigNumber(item.amountOutUSD || '0')
                    const gasUSDBN = new BigNumber('0')
                    const atLeastBN = amountOutUSDBN.minus(gasUSDBN)
                    item['atLeastBN'] = atLeastBN
                    item['amountOutUSDBN'] = amountOutUSDBN
                    return item
                })
                toRouteList = bubbleSort(toRouteList)
            }

            let bestResult = undefined
            if(fromRouteList.length && toRouteList.length) {
                let fromRoute = fromRouteList[0]
                let toRoute = toRouteList[0]

                fromRoute = formatQuoteObj(fromRoute, gasUsdList, fromRoute.chainId, 0.0005, toChainId, isBaseCoin)
                toRoute = formatQuoteObj(toRoute, gasUsdList, toRoute.chainId, 0.001)

                if(fromRoute.lastUsdBN.gte(toRoute.lastUsdBN)) {
                    bestResult = fromRoute
                } else {
                    bestResult = toRoute
                }
            } else if(fromRouteList.length) {
                bestResult = fromRouteList[0]
                bestResult = formatQuoteObj(bestResult, gasUsdList, bestResult.chainId, 0.0005, toChainId, isBaseCoin)
            } else if(toRouteList.length) {
                bestResult = toRouteList[0]
                bestResult = formatQuoteObj(bestResult, gasUsdList, bestResult.chainId, 0.001)
            } else {
                bestResult = undefined
            }
            return bestResult
        }
    } catch(error) {
        throw error
    }
}

interface ApiAggregateQuoteTokenAddress {
    chain: string
    fromToken: string
    toToken: string
    fromDecimals: number
    toDecimals: number
    fromAmount: string
}
export const getAggregateQuoteTokenAddress = async (params:ApiAggregateQuoteTokenAddress, fromChainId: string, toChainId: string, gasUsdList: GasUsd[], direction: string, isBaseCoin: boolean) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/getAggregateQuoteTokenAddress', {params})
        if(code === 0) {
            const bestList = data?.best || []
            const otherList = data?.others || []
            let baseRouteList = []
            let chainId = direction === 'from' ? fromChainId : toChainId

            if(bestList.length) {
                baseRouteList = bestList.filter((item: any) => item?.chainId === chainId)
            }
            if(otherList.length) {
                const bestRouteListByOther = otherList.filter((item: any) => item?.chainId === chainId)
                baseRouteList = [...baseRouteList, ...bestRouteListByOther]
            }

            if(baseRouteList.length) {
                baseRouteList = baseRouteList.map((item:any) => {
                    const amountOutUSDBN = new BigNumber(item.amountOutUSD || '0')
                    const gasUSDBN = new BigNumber('0')
                    const atLeastBN = amountOutUSDBN.minus(gasUSDBN)
                    item['atLeastBN'] = atLeastBN
                    item['amountOutUSDBN'] = amountOutUSDBN
                    return item
                })
                baseRouteList = bubbleSort(baseRouteList)
            }
            let bestResult = undefined
            if(baseRouteList.length) {
                bestResult = baseRouteList[0]
                let rate = 0.0005
                if(direction === 'from') {
                    rate = 0.0005
                } else {
                    rate = 0.001
                }
                bestResult = formatQuoteObj(bestResult, gasUsdList, bestResult.chainId, rate, toChainId, isBaseCoin)
            }

            return bestResult
        }
    } catch(error) {
        return undefined
    }
}


interface ApiAggregateSwapParams {
    chain: string
    aggregator: string
    fromToken: string
    toToken: string
    fromAmount: string
    fromAddress: string
    receiver: string
    slippage: number
    allowPartialFill: boolean
    routeSummary: string
    fromTokenDecimal: string
    toTokenDecimal: string
}
export const getAggregateSwap2 = async (params: ApiAggregateSwapParams) => {
    try {
        const result: any = await request.get('/getAggregateSwap', {params})
        return result
    } catch(error) {
        throw error
    }
}


export interface ApiSubmitOrderParams {
    sourceCerts: string
    orderType: string
    toIndex: string
    slippage?: string
    triggerPrice?: string
    timeout?: string
    toChain: string
    toAddr: string
    execStrategy?: string
    extra?: string
    amountOutMin?: string
    channel: string
}
export const postSubmitOrder = async (params: ApiSubmitOrderParams, headers: {[key:string]: any}, catchInfo: any) => {
    let id = ''
    try {
        const {code = -1, data = {}}: any = await request.post('/submitOrder', params, {
            headers: headers
        })
        if(code === 0) {
            toast.success('Successfully', {
                duration: 3000,
                position: 'top-right',
            })
            id = data.id
        }
    } catch(error) {
        throw error
    } finally {
        catchInfo['id'] = id
        if(!id) {
            catchInfo['status'] = 'failed'
            catchInfo['submit'] = true
        }
        setOrderStore(catchInfo)
    }
}

export const getCheckOrder = async(id: string, originInfo: any) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/checkOrder', {params: { id }})
        if(code === 0) {
            const { execHash = '', reason='', status='' } = data
            originInfo['execHash'] = execHash
            originInfo['reason'] = reason
            originInfo['id'] = id
            if(status === 'Succeeded') {
                originInfo['status'] = 'successful'
            } else if(status === 'Dropped') {
                originInfo['status'] = 'failed'
            } else {
                originInfo['status'] = 'pending'
            }
            setOrderStore(originInfo)
        } else {
            originInfo['id'] = id
            setOrderStore(originInfo)
        }
    } catch(error) {
        throw error
    }
}

// https://api2.chainge.finance/v1/getAssetsByChain?chain=FSN
export const getAssetsByChainBase = async (chainName: string, toTokenName: string) => {
    try {
        const params = {
            chain: chainName
        }
        const {code = -1, data = {}}: any = await request.get('/getAssetsByChain', { params })
        if(code === 0) {
            const list = data.list
            const baseToken = list.find((item: any) => item.symbol === toTokenName)
            return baseToken
        }
    } catch(error) {
        throw error
    }
}

export const sortParams = (params: {[key:string]: any}, evmAddress: string) => {
    let keys = Object.keys(params)
    if(!keys.length) return undefined
    keys = keys.sort();
    const keyValList = []
    for (const key of keys) {
        const val = params[key];
        if(val) {
            keyValList.push(`${key}=${val}`)
        }
    }
    const data = keyValList.join('&')
    const raw = `EvmAddress=${evmAddress}&${data}`
    return raw
}


// 针对路由的专项冒泡排序
const bubbleSort = (array: any[]) => {
    const length = array.length
    if(length === 1) return array
    for(let i = 0; i < length; i++) {
        let flag = false
        for(let j=0; j<length - 1 - i; j++) {
            if(array[j].atLeastBN.lt(array[j+1].atLeastBN)) {
                [array[j], array[j+1]] = [array[j+1], array[j]]
                flag = true
            }
        }
        if(flag === false) return array
    }
    return array
}

// 格式化返回询价结果
const formatQuoteObj = (originObj: any, gasUsdList: GasUsd[], curChainId: string, rate: number, toChainId: string = '', isBaseCoin: boolean = false) => {
    let defaultGasDex = 0
    let gasObj = gasUsdList.find((item: GasUsd) => item.chainId === curChainId)
    if(gasObj) {
        defaultGasDex = gasObj.dex
    }
    // 当是from链时，扣除 ToChainTokenGasFee
    if(rate === 0.0005) {
        // 扣除
        let gasObj = gasUsdList.find((item: GasUsd) => item.chainId === toChainId)
        if(gasObj) {
            defaultGasDex += isBaseCoin ?  gasObj.basecoin : gasObj.token
        }
    }

    const gasDexBN = new BigNumber(defaultGasDex)
    const feeRateBN = new BigNumber(rate)
    const feeUsdBN = originObj.amountOutUSDBN.multipliedBy(feeRateBN)
    const lastUsdBN = originObj.amountOutUSDBN.minus(feeUsdBN).minus(gasDexBN)

    originObj['gasDexUsdBN'] = gasDexBN
    originObj['feeUsdBN'] = feeUsdBN
    originObj['lastUsdBN'] = lastUsdBN
    return originObj
}

// 记录日志
export const setLogByMB = (body: unknown) => {
    // axios.post(`https://openapi.chainge.finance/sign/setLog`, body)
}


// 新的询价接口
// 跨链询价
export interface ApiGetBridgeQuoteParams {
    amount: string
    symbol: string
    fromChain: string
    toChain: string
    extra?: string
}
export const getBridgeQuote = async(params: ApiGetBridgeQuoteParams) => {
    try {
        const response: any = await request.get('/getBridgeQuote', {
            params: params
        })
        return response
    } catch(error) {
        throw error
    }
}

// 交易询价
export interface ApiGetAggregateQuoteParams {
    fromAmount: string
    toTokenAddress: string
    fromDecimal: string
    fromChain: string
    fromTokenAddress: string
    toChain: string
    toDecimal: string
    extra?: string
}
export const getAggregateQuote = async(params: ApiGetAggregateQuoteParams) => {
    try {
        const response: any = await request.get('/getAggregateQuote', {
            params: params
        })
        return response
    } catch(error) {
        throw error
    }
}

interface ApiAggregateSwap2Params {
    chain: string
    aggregator: string
    fromTokenAddress: string
    fromDecimal: string
    fromAmount: string
    toTokenAddress: string
    toDecimal: string
    sender: string
    recipient: string
    slippage: string
    allowPartialFill: boolean
    routeSummary: string
}
export const getAggregateSwap = async (params: ApiAggregateSwap2Params) => {
    try {
        const result: any = await request.get('/getAggregateSwap', {params})
        return result
    } catch(error) {
        throw error
    }
}